export const MOVE_TO_TOP_MENU_ID = 'actions/move-to/top' as const;
export const MOVE_UP_MENU_ID = 'actions/move-to/up' as const;
export const MOVE_DOWN_MENU_ID = 'actions/move-to/down' as const;
export const MOVE_TO_BOTTOM_MENU_ID = 'actions/move-to/bottom' as const;
